import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function HeroSection() {
  // Countdown timer logic (15 minutes)
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="w-full bg-[#f9f8f4] font-['Montserrat',_sans-serif] flex flex-col" data-id="element-190">
      {/* Urgency Bar */}
      <div className="w-full bg-[#1e2330] border-b-[4px] border-[#f59e0b] py-3 px-4 flex justify-center items-center text-center z-10" data-id="element-191">
        <div className="flex items-center justify-center flex-wrap gap-2 text-white font-bold text-sm md:text-base tracking-wide" data-id="element-192">
          <Clock className="w-5 h-5 fill-white text-[#1e2330]" data-id="element-193" />
          <span data-id="element-194">🔥 ÚLTIMOS 3 CUPOS CON BONOS Y PRECIO CONGELADO:</span>
          <span className="text-[#facc15] ml-1" data-id="element-195">{formattedTime}</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center pt-16 pb-8 px-4 md:px-8 max-w-[1000px] mx-auto text-center" data-id="element-196">
        {/* Pre-headline */}
        <p className="text-[#388e3c] font-bold text-sm md:text-base lg:text-lg tracking-wide mb-6 uppercase" data-id="element-197">
          Si tenés una cocina en tu casa, ya tenés un negocio en tus manos.
        </p>

        {/* Main Headline */}
        <h1 className="font-['Playfair_Display',_serif] text-4xl md:text-5xl lg:text-[64px] font-bold text-[#111827] leading-[1.1] mb-10 max-w-[900px]" data-id="element-198">
          Facturá{' '}
          <span className="underline decoration-[#4ade80] decoration-[4px] md:decoration-[6px] underline-offset-[6px] md:underline-offset-[8px]" data-id="element-199">
            más de $3
          </span>{' '}
          <span className="underline decoration-[#4ade80] decoration-[4px] md:decoration-[6px] underline-offset-[6px] md:underline-offset-[8px]" data-id="element-200">
            millones mensuales
          </span>{' '}
          con el negocio de viandas sin arriesgar un peso
        </h1>

        {/* Subtitle Pill */}
        <div className="bg-[#fae8c8] rounded-full py-3 px-6 md:px-10 mb-12 inline-block" data-id="element-201">
          <p className="text-[#111827] font-bold text-base md:text-xl lg:text-2xl" data-id="element-202">
            Cobrá ANTES de cocinar y construí libertad financiera desde tu
            cocina
          </p>
        </div>

        {/* Support Text */}
        <div className="max-w-[850px] text-[#374151] text-lg md:text-xl lg:text-[22px] leading-relaxed" data-id="element-203">
          <p data-id="element-204">
            💰 El Sistema de Pre-Venta que usan{' '}
            <span className="font-bold text-black" data-id="element-205">
              +37.893 madres emprendedoras
            </span>
            : Vendés antes de comprar ingredientes,{' '}
            <span className="underline decoration-1 underline-offset-4" data-id="element-206">
              cobrás antes de invertir
            </span>
            , y{' '}
            <span className="font-bold text-black" data-id="element-207">
              generás ingresos predecibles
            </span>{' '}
            mientras estás presente para tu familia.{' '}
            <span className="font-bold text-black" data-id="element-208">
              Sin jefes, sin descuidar a tus hijos,{' '}
              <span className="underline decoration-2 underline-offset-4" data-id="element-209">
                sin improvisar precios que te hagan trabajar gratis
              </span>
              .
            </span>
          </p>
        </div>
      </div>
    </div>;
}